<template>
    <div>
        <image-control :image-id="form.image_id"
                       v-model="form.image_id"
                       @event="form.listen(form, $event)"></image-control>

        <form-group type="text"
                    label="Slug"
                    id="slug"
                    v-model="form.slug"
                    :error="form.errors.get('slug')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    label="Name"
                    id="name"
                    v-model="form.name"
                    :error="form.errors.get('name')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    label="Plural"
                    id="plural"
                    v-model="form.plural"
                    :error="form.errors.get('plural')"
                    @event="form.listen(form, $event)">
        </form-group>

        <button type="button" class="button is-primary" @click="submit()">Save</button>
    </div>
</template>

<script>
    import Form from "../../helpers/Form"
    import {mapGetters} from "vuex"
    import {CREATE_ITEM, UPDATE_ITEM} from "../../store/mutation-types"
    export default {
        props: {
            item: {
                type: [String, Object], default: () => {
                    return {
                        slug: '',
                        name: '',
                        description: '',
                    }
                }
            },
            create: {type: [Boolean], default: false}
        },
        data() {
            return {
                form: new Form(this, this.item, this.create ? CREATE_ITEM : UPDATE_ITEM)
            }
        },
        methods: {
            submit() {
                this.form.submit().then(data => {
                    this.$emit('saved', data)
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ItemForm.vue?7f8c843f